<div class="tooltip" [class]="position">
  <div class="content-wrapper">
    <span>!</span>
    <div class="content" [ngClass]="contentClass" routeTransformer>
      <div [innerHTML]="warningContent" class="bg-orange text-white p-4 mb-4 rounded-md"></div>
      <div [innerHTML]="tooltipContent"></div>
    </div>
  </div>
</div>
